<div class="main-div">
    
    <div class="upload-div">

        <div class="heading">
            UPLOAD
        </div>

        <div class="sub-div">
            <div class="title">
                <p>Please provide the complete link/URL to the new episode video. We accept both YouTube and Vimeo video links.
                    Please
                    follow the instructions below.</p>
            </div>

            <div class="instructions">
                <span>YouTube video:</span>
                <ul>
                    <li>Upload the video to YouTube.</li>
                    <li>In case the contents are not to be released publicly on YouTube, select "UNLISTED" while uploading the video.
                        Note - Unlisted YouTube videos do not show up on YouTube or Google search results.</li>
                    <li>Paste the complete link/URL to the uploaded video in the box below.</li>
                    <li>For videos already present on YouTube, directly paste the complete URL in the box below.</li>
                    <li>YouTube video sample format - <a href="https://www.youtube.com/watch?v=d98nYvl83Ls">
                        <span>https://www.youtube.com/watch?v=d98nYvl83Ls</span></a></li>
                    <li>Please do not paste links to videos that are marked as PRIVATE when uploading.</li>
                </ul>
                <span>Vimeo video:</span>
                <ul>
                    <li>Upload the video to Vimeo.</li>
                    <li>Select "ANYONE" in the privacy settings while uploading the video. If the contents are not to be released
                        publicly on Vimeo, select the "PRIVATE LINK" option. Note - Vimeo Pro users have the privilege to use the
                        Private Link option.</li>
                    <li>Paste the complete link/URL to the uploaded video in the box below.</li>
                    <li>For videos already present on Vimeo, directly paste the complete URL in the box below.</li>
                    <li>Vimeo video sample format - <a href="https://vimeo.com/167970538">
                        <span>https://vimeo.com/167970538</span></a></li>
                    <li>Please do not paste links to videos that are marked as PASSWORD PROTECTED when uploading.</li>
                </ul>
            </div>

            <div class="form-fields">
                <form [formGroup]="uploadStage" method="post">
                    <div>
                        <label>Paste the URL below:</label><br>
                        <input type="text" class="form-control" placeholder="Paste URL" formControlName="videoUrl" required>
                    </div>
                    <br>
                    <div>
                        <label>Title:</label><br>
                        <input type="text" class="form-control" placeholder="Add Title" id="mainTitle" name="mainTitle" formControlName="mainTitle"
                         required>
                    </div>
                    <br>
                    <div class="thumbnail-image ">
                        <label>Thumbnail Image</label><br>
                        <img [src]="uploadStage.get('thumbnailImage').value" alt=""><br>
                        <input type="file" accept="image/*" name="" id="" (change)="onFileSelected($any($event).target.files[0])"><br>
                    </div>
                    <div>
                        <label>Sequence:</label>
                        <input type="number" class="form-control" min="1" placeholder="Sequence" formControlName="sequence"><br>
                    </div>
                    <div class="center-button">
                        <button type="submit" [disabled]="uploadStage.invalid" (click)="postHitmakerVideo()">Submit</button>
                    </div>
                </form>
            </div>

            <div class="note">
                <p>Please add here to the respective guidelines while uploading the video on YouTube or Vimeo. Prohibited content will be
                removed.</p>
            </div>
            
        </div>
    </div>
</div>